var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17383 17.379C3.84815 17.3777 2.57715 16.8505 1.63976 15.9131C0.702361 14.9757 0.175152 13.7047 0.173828 12.379L0.173828 6.607C0.175416 5.2814 0.70271 4.01055 1.64005 3.07322C2.57739 2.13588 3.84823 1.60858 5.17383 1.607H10.6178C10.8658 1.60726 11.1135 1.62564 11.3588 1.662L9.30583 3.762H5.27983C4.48418 3.762 3.72112 4.07807 3.15851 4.64068C2.5959 5.20328 2.27983 5.96635 2.27983 6.762V12.233C2.27983 13.0286 2.5959 13.7917 3.15851 14.3543C3.72112 14.9169 4.48418 15.233 5.27983 15.233H10.5128C11.3085 15.233 12.0715 14.9169 12.6341 14.3543C13.1968 13.7917 13.5128 13.0286 13.5128 12.233V8.274L15.5968 6.145C15.6118 6.306 15.6188 6.461 15.6188 6.608V12.381C15.6175 13.7067 15.0903 14.9777 14.1529 15.9151C13.2155 16.8525 11.9445 17.3797 10.6188 17.381L5.17383 17.379ZM8.00683 7.204L14.0848 0.995995C14.2464 0.839807 14.4375 0.717586 14.6471 0.636556C14.8567 0.555526 15.0804 0.517331 15.305 0.52423C15.5295 0.531129 15.7505 0.582981 15.9547 0.676721C16.1589 0.770462 16.3422 0.904188 16.4938 1.07C16.8236 1.39043 17.0156 1.82675 17.0291 2.28639C17.0425 2.74604 16.8764 3.19284 16.5658 3.532L10.4888 9.738L7.14383 10.623L8.00683 7.204Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6868188d.svg";
export { ForwardRef as ReactComponent };